import { useEffect, useLayoutEffect, useRef, useState } from 'react';

// This ensures the effect only runs on the client
const useIsomorphicLayoutEffect =
  typeof window !== 'undefined' ? useLayoutEffect : useEffect;

/**
 * Custom hook to measure and return the height of the tallest option
 * @param {Array} options - Array of option objects
 * @returns {number|undefined} - Height of the tallest option, undefined if no subtexts present
 */
const useGetOptionHeights = ({
  options,
  componentPage,
  isTiled,
  allOptionsHaveIcons,
}) => {
  const [tallestOptionHeight, setTallestOptionHeight] = useState(undefined);

  const optionRefs = useRef({});

  useIsomorphicLayoutEffect(() => {
    const hasSubtext = options.some(
      (option) => option.subtext && option.subtext.length > 0
    );
    if (!hasSubtext) {
      return;
    }
    if (componentPage === 0) {
      // Set a default height for the first page to avoid excessive layout shifts during initial adjustments.
      setTallestOptionHeight(isTiled ? 200 : 80);
      return;
    }
    if (Object.keys(optionRefs.current).length > 0) {
      let maxHeight = 0;

      Object.values(optionRefs.current).forEach((ref) => {
        if (ref && ref.offsetHeight) {
          maxHeight = Math.max(maxHeight, ref.offsetHeight);
        }
      });

      if (maxHeight > 0) {
        // Add extra padding for icon-less buttons with sub-text on non-first pages
        if (!allOptionsHaveIcons) {
          maxHeight += 15;
        }
        setTallestOptionHeight(maxHeight);
      }
    }
  }, [options]);

  return { tallestOptionHeight, optionRefs };
};

export default useGetOptionHeights;
